__turbopack_context__.v({
  "button": "report-form-module-scss-module__cWOVpq__button",
  "files_description": "report-form-module-scss-module__cWOVpq__files_description",
  "files_field": "report-form-module-scss-module__cWOVpq__files_field",
  "files_section": "report-form-module-scss-module__cWOVpq__files_section",
  "row": "report-form-module-scss-module__cWOVpq__row",
  "textarea": "report-form-module-scss-module__cWOVpq__textarea",
});
